export type ArticleSection = {
  heading?: string;
  text: string;
};

export type Article = {
  id: string;
  title: string;
  categoryId: string;
  category: string;
  excerpt: string;
  cover: string;
  heat: number;
  views: number;
  date: string;
  submitter: string;
  status: "发酵中" | "已核实" | "待补充";
  tags: string[];
  comments: number;
  content: ArticleSection[];
};

export const articles: Article[] = [
  {
    id: "variety-cast-rumor",
    title: "某口碑综艺第三季录制在即，常驻阵容或将大换血",
    categoryId: "entertainment",
    category: "娱乐圈",
    excerpt:
      "多名现场工作人员先后向511爆料投喂线索，称这档以真实感著称的口碑综艺第三季已进入集结阶段，但上一季的四位常驻里只有两人出现在最新通告单上。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20warm%20toned%20empty%20television%20studio%20stage%20with%20soft%20spotlights%20and%20blurred%20silhouettes%20in%20the%20background%2C%20editorial%20magazine%20photography%2C%20muted%20amber%20and%20deep%20red%20palette%2C%20clean%20minimal%20composition%2C%20high%20detail&width=1200&height=800&seq=gossip-variety-cast&orientation=landscape",
    heat: 9850,
    views: 86420,
    date: "2026-09-09",
    submitter: "匿名・场务老张",
    status: "发酵中",
    tags: ["综艺", "阵容变动", "录制"],
    comments: 412,
    content: [
      {
        text: "从九月上旬开始，511爆料后台陆续收到同一档综艺的零散线索。几位自称参与过前两季录制的现场工作人员表示，第三季的集结通告已经下发，但名单和上一季相比变化明显。",
      },
      {
        heading: "通告单上的四个名字，只留下两个",
        text: "投稿人提供的通告单截图显示，上一季的四位常驻嘉宾中，有两位并未出现在新一季的集合时间表里。另一条线索则称，节目组正在接触两位近两年综艺表现突出的新人，其中一位来自音乐综艺赛道。",
      },
      {
        heading: "换人不等于翻脸",
        text: "需要说明的是，阵容调整在长周期综艺中并不罕见。有线索指向档期冲突而非关系破裂，节目常规的商务与拍摄周期在秋冬集中，艺人档期本就紧张。这一点我们仍在向多方交叉核实。",
      },
      {
        heading: "后台如何跟进",
        text: "目前这条爆料已进入发酵环节：我们已把通告单、到岗时间和场地坐标拆分成三个独立的信息点，分别送往不同信源核对。任一项被证实或证伪，都会在页面更新进度标签。",
      },
      {
        text: "如果你也掌握本季录制的现场信息，可以通过私信投稿或投稿表单继续补充，同一爆料支持多次追加，不需要重复提交。",
      },
    ],
  },
  {
    id: "live-stream-oversell",
    title: "百万粉丝主播专场被指货不对板，售后群一夜解散",
    categoryId: "creator",
    category: "网红圈",
    excerpt:
      "多位下单用户在511爆料匿名投稿，称一场预热半个月的专场直播存在批次差异，收货后客服群在凌晨突然清空成员。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20smartphone%20ring%20light%20and%20stacked%20parcel%20boxes%20in%20a%20warm%20studio%20corner%2C%20editorial%20documentary%20style%2C%20soft%20amber%20lighting%20with%20deep%20red%20accents%2C%20minimal%20clean%20background%2C%20high%20detail&width=1200&height=800&seq=gossip-live-stream&orientation=landscape",
    heat: 8720,
    views: 61300,
    date: "2026-09-08",
    submitter: "匿名・买家小K",
    status: "发酵中",
    tags: ["直播带货", "售后", "消费"],
    comments: 356,
    content: [
      {
        text: "这条线索的投稿人不止一位。截至整理时，后台共收到十七份相互独立的投喂材料，时间集中在专场直播结束后的第五天到第七天。",
      },
      {
        heading: "发货批次与样品存在差异",
        text: "多位用户晒出对比图，认为实际收到的商品与直播间展示的样品在包装与配件数量上存在出入。也有用户表示自己收到的货没有问题，说明批次差异可能是分仓造成的，而非全部订单。",
      },
      {
        heading: "凌晨清空客服群",
        text: "最集中的反馈是售后群在凌晨被解散。截图显示群成员数从四位数归零，随后原群主更换了账号昵称。这一操作是主动规避还是系统风控，目前没有定论。",
      },
      {
        heading: "匿名投稿为什么要写这些",
        text: "我们保留了投稿人对细节的描述，同时对涉及个人身份的信息做了脱敏处理。投喂瓜料的价值在于可核对的时间线，而不是情绪化的指控，这也是后台审核时最看重的一点。",
      },
    ],
  },
  {
    id: "drama-role-change",
    title: "古装大制作拍摄过半换女主角，剧组内部说法不一",
    categoryId: "entertainment",
    category: "娱乐圈",
    excerpt:
      "一条来自横店场务的私信投稿称，某平台S级古装剧在拍摄过半后调整女主，补拍计划已经排上日程。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20empty%20ancient%20chinese%20film%20set%20with%20wooden%20pavilion%20and%20hanging%20silks%20at%20dusk%2C%20cinematic%20editorial%20photography%2C%20warm%20amber%20and%20muted%20crimson%20tones%2C%20soft%20haze%2C%20clean%20minimal%20composition&width=1200&height=800&seq=gossip-drama-set&orientation=landscape",
    heat: 7640,
    views: 52900,
    date: "2026-09-07",
    submitter: "匿名・片场打光师",
    status: "待补充",
    tags: ["影视", "换角", "横店"],
    comments: 289,
    content: [
      {
        text: "投稿人自称在横店某古装剧组担任灯光组工作，拍到第五十六天时接到通知，部分已经杀青的女主戏份需要重新排期。",
      },
      {
        heading: "两种截然不同的说法",
        text: "一种说法是艺人身体原因需要休养，另一种说法则指向创作方向调整。由于两种解释都来自剧组内部的间接转述，我们在标题与正文中都保留了不确定表述。",
      },
      {
        heading: "补拍对制作周期的影响",
        text: "按行业惯例，主角补拍会带来布景复建与群演重组的额外成本。有从业者向511爆料表示，这类调整通常会让整部剧的后期周期延后两到三个月。",
      },
      {
        text: "如果你手上有通告单或场记信息，欢迎通过投稿入口补充。线索越具体，越容易进入发酵环节。",
      },
    ],
  },
  {
    id: "brand-endorsement-split",
    title: "品牌与代言人合约提前终止？公关群里流出的一页文档",
    categoryId: "business",
    category: "商界风闻",
    excerpt:
      "一份来源不明的内部文档截图在多个行业群里流传，指向某消费品牌与代言人提前结束合作。文档真伪待核。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20minimal%20office%20desk%20with%20blank%20contract%20papers%2C%20a%20pen%20and%20a%20cup%20of%20tea%2C%20warm%20neutral%20lighting%2C%20editorial%20business%20photography%2C%20amber%20and%20deep%20red%20subtle%20accents%2C%20clean%20background%2C%20high%20detail&width=1200&height=800&seq=gossip-brand-doc&orientation=landscape",
    heat: 6310,
    views: 41200,
    date: "2026-09-06",
    submitter: "匿名・前市场部员工",
    status: "待补充",
    tags: ["代言", "品牌", "合约"],
    comments: 174,
    content: [
      {
        text: "投稿人表示自己在离职前接触过相关项目，但提供的只有一页文档照片，缺少公章与签署页，因此这条线索目前只做展示，不下结论。",
      },
      {
        heading: "行业惯例与解读",
        text: "代言合约提前终止在快消与美妆领域并不少见，通常与销量考核、舆情评估或艺人档期有关。单凭一页文档无法判断属于哪一类。",
      },
      {
        heading: "后台核验方式",
        text: "我们已把品牌名、时间节点与文档版本号拆开分别核对，并联系了两位独立信源。任何一项被证实后会第一时间更新状态标签。",
      },
    ],
  },
  {
    id: "workplace-overtime-log",
    title: "一份被误发到全员群的排班表，让这个团队上了同城热搜",
    categoryId: "workplace",
    category: "职场爆料",
    excerpt:
      "匿名投稿称，某互联网团队的值班表因操作失误进入全员群，随后的讨论截图进一步扩散，引发对加班安排的关注。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20late%20night%20open%20plan%20office%20with%20a%20few%20lit%20desk%20lamps%20and%20empty%20chairs%2C%20editorial%20documentary%20photography%2C%20warm%20amber%20glow%20against%20dark%20red%20shadows%2C%20quiet%20minimal%20composition&width=1200&height=800&seq=gossip-workplace&orientation=landscape",
    heat: 5480,
    views: 38700,
    date: "2026-09-05",
    submitter: "匿名・离职两周",
    status: "已核实",
    tags: ["职场", "加班", "团队"],
    comments: 233,
    content: [
      {
        text: "这条线索经过两位在职员工的交叉确认，排班表的存在与大致内容可信度较高，已被标记为已核实。",
      },
      {
        heading: "讨论是怎样扩散的",
        text: "最初的截图只在小范围内流传，真正的扩散发生在一段语音被转成文字之后。多位投稿人表示，外界看到的版本已经过多次转述，与原始内容有出入。",
      },
      {
        heading: "对行业的提醒",
        text: "无论最终走向如何，这类事件反映的其实是排班透明度问题。把线索交给511爆料，是希望讨论聚焦在制度本身，而不是某一个人的失误。",
      },
    ],
  },
  {
    id: "campus-club-funding",
    title: "校园社团经费去向引质疑，学生自制的收支表被大量转发",
    categoryId: "campus",
    category: "校园见闻",
    excerpt:
      "多名在校学生匿名投稿，称某高校社团年度经费明细存在缺项，学生自制的收支表在校园论坛被反复搬运。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20university%20campus%20walkway%20in%20early%20autumn%20with%20warm%20leaves%20and%20soft%20sunlight%2C%20editorial%20photography%2C%20muted%20amber%20and%20beige%20palette%20with%20subtle%20red%20accents%2C%20clean%20minimal%20framing&width=1200&height=800&seq=gossip-campus&orientation=landscape",
    heat: 4260,
    views: 27400,
    date: "2026-09-04",
    submitter: "匿名・大三在读",
    status: "待补充",
    tags: ["校园", "社团", "经费"],
    comments: 128,
    content: [
      {
        text: "投稿人提供了学生自制的收支表照片，表格覆盖一个学年的活动开支，部分条目缺少票据说明。",
      },
      {
        heading: "学生的诉求很具体",
        text: "多位投稿人的诉求并非情绪宣泄，而是希望公开完整明细。有同学向511爆料表示，他们更关心制度如何补上缺口，而不是追究个别人。",
      },
      {
        text: "如果你也了解相关情况，可以通过表单投稿补充时间线，帮助线索进入发酵环节。",
      },
    ],
  },
  {
    id: "roadshow-booking",
    title: "新片路演场次临时调整，多地影迷收到退票短信",
    categoryId: "entertainment",
    category: "娱乐圈",
    excerpt:
      "有影迷向511爆料投稿，称已购票的某新片路演场次在开场前一日被集中退票，官方给出的理由并不统一。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20warm%20lit%20cinema%20hall%20with%20red%20velvet%20seats%20and%20an%20empty%20screen%2C%20editorial%20photography%2C%20amber%20and%20deep%20crimson%20palette%2C%20soft%20grain%2C%20minimal%20composition&width=1200&height=800&seq=gossip-roadshow&orientation=landscape",
    heat: 3970,
    views: 24100,
    date: "2026-09-03",
    submitter: "匿名・场次观众",
    status: "发酵中",
    tags: ["路演", "退票", "新片"],
    comments: 96,
    content: [
      {
        text: "投稿截图显示，退票短信在不同城市几乎同时发出，但措辞不一：有的写档期调整，有的写场地原因。",
      },
      {
        heading: "观众最在意的不是退钱",
        text: "多位投稿人表示退票本身可以接受，真正让人困惑的是信息不透明。有观众为了路演跨城出行，临时取消带来了额外成本。",
      },
      {
        heading: "我们关注什么",
        text: "511爆料更愿意把注意力放在可核对的时间线上：退票短信的发送时间、场次编号与官方公告的对应关系。这些才是有价值的瓜料。",
      },
    ],
  },
  {
    id: "consumer-service-trap",
    title: "连锁门店预付费退款排队，门店只留一个咨询电话",
    categoryId: "life",
    category: "生活圈",
    excerpt:
      "匿名投稿称，多家连锁门店的预付费退款排到两个月后，客服热线长期占线，消费者只能线下排队登记。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20queue%20barrier%20tape%20and%20an%20empty%20service%20counter%20in%20a%20warm%20lit%20store%20interior%2C%20editorial%20documentary%20style%2C%20amber%20and%20muted%20beige%20palette%20with%20red%20signage%20accents%2C%20clean%20composition&width=1200&height=800&seq=gossip-consumer&orientation=landscape",
    heat: 3520,
    views: 21800,
    date: "2026-09-02",
    submitter: "匿名・会员卡用户",
    status: "发酵中",
    tags: ["预付费", "退款", "消费"],
    comments: 141,
    content: [
      {
        text: "投稿人提供了登记排号照片，排号单上的日期跨度接近两个月，说明退款处理能力明显不足。",
      },
      {
        heading: "预付费风险的常见信号",
        text: "门店缩减、电话占线、只能线下登记，通常是现金流紧张的信号。业内从业者向511爆料表示，提前保留消费凭证与合同是最有效的自保方式。",
      },
      {
        text: "本条线索仍在发酵，欢迎补充其他城市的门店情况，我们会按城市归档。",
      },
    ],
  },
  {
    id: "music-festival-lineup",
    title: "音乐节阵容海报被指“先卖票后补人”，主办方回应含糊",
    categoryId: "entertainment",
    category: "娱乐圈",
    excerpt:
      "多位购票者在511爆料投稿，称某音乐节首批海报上的乐队与实际排期不符，临时换阵的情况出现在同一舞台的多个时段。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20music%20festival%20stage%20at%20night%20with%20abstract%20warm%20stage%20lights%20and%20a%20distant%20crowd%20silhouette%2C%20editorial%20photography%2C%20amber%20gold%20and%20deep%20red%20palette%2C%20soft%20bokeh%2C%20clean%20composition&width=1200&height=800&seq=gossip-festival&orientation=landscape",
    heat: 7830,
    views: 49600,
    date: "2026-09-01",
    submitter: "匿名・三年老乐迷",
    status: "发酵中",
    tags: ["音乐节", "阵容", "购票"],
    comments: 318,
    content: [
      {
        text: "投稿人整理了海报与现场排期的逐条对照表，指出三个时段存在替换，且替换消息发布滞后于开票时间。",
      },
      {
        heading: "为什么这类线索容易被采纳",
        text: "因为它可核对。海报、排期表、公告时间戳都是客观材料，不依赖主观判断，这也是后台审核最欢迎的投稿方式。",
      },
      {
        heading: "乐迷真正关心的事",
        text: "多数投稿人表示愿意为好阵容付费，反感的是信息不对称。有乐迷向511爆料建议，主办方至少应在开票前锁定主力阵容。",
      },
    ],
  },
  {
    id: "studio-conflict",
    title: "两位合作多年的搭档疑似拆伙，工作室注册信息出现变化",
    categoryId: "creator",
    category: "网红圈",
    excerpt:
      "一条查证类投稿称，某内容创作者组合的合作主体近期完成变更，双方账号的更新节奏也出现明显错位。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20minimal%20creator%20studio%20with%20two%20empty%20chairs%20facing%20a%20softbox%20and%20camera%20on%20tripod%2C%20editorial%20photography%2C%20warm%20amber%20and%20muted%20brown%20palette%20with%20red%20accent%2C%20clean%20background&width=1200&height=800&seq=gossip-studio-split&orientation=landscape",
    heat: 5940,
    views: 36500,
    date: "2026-08-30",
    submitter: "匿名・同行观察",
    status: "待补充",
    tags: ["创作者", "合作", "拆伙"],
    comments: 187,
    content: [
      {
        text: "投稿人通过公开的企业信息查询发现，原合作主体的股东结构发生变化，但这只能说明商业安排有调整，不等于内容合作终止。",
      },
      {
        heading: "更新节奏的错位",
        text: "另一位投稿人统计了两个账号近两个月的更新频率，指出联合出镜的比例下降。这个观察属于现象层面，仍在等待更多材料。",
      },
      {
        text: "线索欢迎持续补充。511爆料匿名投稿入口长期开放，同一话题可多次投喂。",
      },
    ],
  },
  {
    id: "delivery-worker-tip",
    title: "外卖高峰时段系统派单争议，骑手群流传一张调度截图",
    categoryId: "workplace",
    category: "职场爆料",
    excerpt:
      "多名骑手匿名投稿，称高峰期出现明显超出常规距离的派单，群内流传的调度截图被认为与算法调整有关。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20city%20street%20at%20dusk%20with%20warm%20street%20lamps%20and%20blurred%20motion%20lights%2C%20editorial%20photography%2C%20amber%20and%20deep%20red%20palette%2C%20rain%20slick%20asphalt%20reflection%2C%20minimal%20composition&width=1200&height=800&seq=gossip-delivery&orientation=landscape",
    heat: 4680,
    views: 29900,
    date: "2026-08-29",
    submitter: "匿名・夜班骑手",
    status: "待补充",
    tags: ["骑手", "派单", "算法"],
    comments: 158,
    content: [
      {
        text: "投稿人提供了调度截图，但截图缺少时间水印，我们无法确认具体的调整生效区间，因此暂标记为待补充。",
      },
      {
        heading: "骑手们更想聊清楚的事",
        text: "多位投稿人提到，比起具体一单的远近，他们更关心派单规则是否公开。有骑手向511爆料表示，透明度提升比单笔补贴更重要。",
      },
      {
        text: "如果你手上有带时间信息的调度记录，欢迎补充，这类材料最容易推动线索进入发酵。",
      },
    ],
  },
  {
    id: "ticket-scalper-track",
    title: "演出门票开售即秒空，二级市场同分钟出现连号票",
    categoryId: "life",
    category: "生活圈",
    excerpt:
      "匿名投稿对比了官方开售时间与二级市场上架时间，认为存在分钟级的同步，侧面印证了抢票工具的参与。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20concert%20ticket%20stubs%20and%20a%20phone%20screen%20showing%20a%20sold%20out%20notice%2C%20flat%20lay%20editorial%20photography%2C%20warm%20amber%20and%20deep%20red%20palette%2C%20clean%20minimal%20background%2C%20high%20detail&width=1200&height=800&seq=gossip-ticket&orientation=landscape",
    heat: 5160,
    views: 33100,
    date: "2026-08-28",
    submitter: "匿名・抢票失败者",
    status: "发酵中",
    tags: ["演出", "门票", "二级市场"],
    comments: 202,
    content: [
      {
        text: "投稿人做了一张时间对照表：官方开售 20:00:00，二级平台上架 20:00:41。这个时间差本身不能作为直接证据，但值得记录。",
      },
      {
        heading: "连号票意味着什么",
        text: "连号票通常来自同一批次的分配。有行业从业者向511爆料解释，这与主办方预留、赞助商配票等多种渠道都有关，不能单一归因。",
      },
      {
        text: "线索仍在发酵，欢迎补充更多场次的时间对照材料。",
      },
    ],
  },
  {
    id: "industry-training-myth",
    title: "“包进组”培训班被学员集中投诉，宣传话术清一色复制粘贴",
    categoryId: "campus",
    category: "校园见闻",
    excerpt:
      "多位学员投稿，称某表演培训班承诺的进组机会与实际情况不符，招生话术在不同城市的宣传页上高度雷同。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20empty%20dance%20rehearsal%20room%20with%20wooden%20floor%20and%20mirror%20wall%2C%20warm%20afternoon%20light%2C%20editorial%20photography%2C%20amber%20and%20muted%20beige%20palette%20with%20subtle%20red%20accent%2C%20clean%20composition&width=1200&height=800&seq=gossip-training&orientation=landscape",
    heat: 3240,
    views: 19600,
    date: "2026-08-27",
    submitter: "匿名・退课学员",
    status: "待补充",
    tags: ["培训", "招生", "投诉"],
    comments: 87,
    content: [
      {
        text: "投稿人比对了两座城市的招生宣传页，发现承诺条款的表述几乎完全一致，连错别字都相同。",
      },
      {
        heading: "提醒后来的学员",
        text: "行业里确有机会，但任何把结果写死的承诺都值得谨慎。有从业者向511爆料建议，缴费前应索要书面条款而不是口头保证。",
      },
      {
        text: "如果你也有类似经历，欢迎通过投稿表单补充证据，我们会按机构分类归档。",
      },
    ],
  },
  {
    id: "art-toy-drop",
    title: "潮玩限定发售规则临时更改，门店外的排队视频引发讨论",
    categoryId: "business",
    category: "商界风闻",
    excerpt:
      "有玩家向511爆料投稿，称某潮玩品牌临时把线上抽签改为线下限量，现场排队秩序一度混乱。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20shelf%20of%20abstract%20colorful%20designer%20toy%20figures%20in%20a%20warm%20lit%20boutique%2C%20editorial%20product%20photography%2C%20amber%20and%20deep%20red%20palette%2C%20soft%20shadows%2C%20clean%20minimal%20background&width=1200&height=800&seq=gossip-arttoy&orientation=landscape",
    heat: 2890,
    views: 17200,
    date: "2026-08-26",
    submitter: "匿名・资深玩家",
    status: "待补充",
    tags: ["潮玩", "发售", "排队"],
    comments: 74,
    content: [
      {
        text: "投稿人表示,发售前四十八小时仍显示线上抽签，直到当天清晨才更新为线下限量，不少玩家已经在路上。",
      },
      {
        heading: "规则变化的连锁反应",
        text: "改规则本身不一定违规，但会直接改变玩家预期。有玩家向511爆料称，最令人失望的是官方沟通滞后。",
      },
    ],
  },
];

export const getArticleById = (id: string): Article | undefined =>
  articles.find((item) => item.id === id);

export const getRelatedArticles = (article: Article, limit = 3): Article[] => {
  const sameCategory = articles.filter(
    (item) => item.id !== article.id && item.categoryId === article.categoryId,
  );
  const others = articles.filter(
    (item) => item.id !== article.id && item.categoryId !== article.categoryId,
  );
  return [...sameCategory, ...others].slice(0, limit);
};